export default __webpack_public_path__ + "41bd006039b8772d0823e8716777f160.svg";